/* eslint-disable @typescript-eslint/no-explicit-any */
import { ContentBlockFragment, PageBetpickLinkFragment } from '@graphqlTypes/sitecore';
import React, { useEffect, useMemo, useState } from 'react';
import BetPickEntry from './bet-pick-entry';
import { BetPickDetail } from '@mobx/stores/kol/kol-store';
import { GetOddsDataQuery } from '@src/hooks/GetOddsDataQuery';
import { GetRacingDataQuery } from '@src/hooks/GetRacingDataQuery';
import BetPickNewEntry from './bet-pick-new-entry';
// import { IsNewBetType } from '@src/utils/kolBetpickUtils';
import { format, isSameDay } from 'date-fns';
import { jsBridge } from '@src/utils/js-bridge';
import bettingStrategyStore from '@mobx/stores/bettingStrategy-store';
import { toZonedTime } from 'date-fns-tz';

type Props = {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    content: PageBetpickLinkFragment | any;
    updateShowChanges: (i: boolean) => void;
    contentBlock: ContentBlockFragment | any;
};

/** 用于article betpick组件 */
function BetPickLink({ content, updateShowChanges, contentBlock }: Props) {
    const [racesList, setRacesList] = useState([]);
    const [oddsList, setOddsList] = useState([]);
    const [raceRunner, setRaceRuner] = useState([]);

    // console.log('article content=====', content);

    /** 是否手动输入，不请求API */
    const displayManualInput =
        content?.betpickLink?.targetItem?.race?.meeting?.displayManualInput?.boolValue;

    /** betpick是否启用 */
    const isBetPickEntry = content?.betpickLink.targetItem;

    // console.log('isBetPickEntry************', !isBetPickEntry);

    const detail = useMemo<BetPickDetail | undefined>(() => {
        if (!content.betpickLink?.targetItem) {
            return undefined;
        }
        return {
            betpick: content.betpickLink.targetItem,
            leader: content.betpickLink.targetItem?.kol?.targetItem,
            race: content.betpickLink.targetItem?.race,
            raceDay: content.betpickLink.targetItem?.race?.meeting,
        };
    }, [content.betpickLink?.targetItem]);

    const getOddsData = async () => {
        const race = content?.betpickLink?.targetItem?.race;

        const racesNo = race?.raceNo?.numberValue ?? 0;
        const hongKongTime = toZonedTime(
            new Date(race?.meeting?.raceDayDate?.dateValue ?? 0),
            'Asia/Hong_Kong'
        );
        const raceDay = format(hongKongTime, 'yyyy-MM-dd');

        try {
            const oddsResult = await GetOddsDataQuery(
                raceDay,
                race?.meeting?.venueCode?.value ?? '',
                racesNo ?? 0
            );
            setOddsList(oddsResult.length > 0 ? oddsResult[0].pmPools ?? [] : []);
        } catch (error) {
            console.error('Error fetching odds data:', error);
        }
    };

    const getRacingData = async () => {
        const meeting = content?.betpickLink?.targetItem?.race?.meeting;

        const hongKongTime = toZonedTime(
            new Date(meeting?.raceDayDate?.dateValue ?? 0),
            'Asia/Hong_Kong'
        );
        const raceDay = format(hongKongTime, 'yyyy-MM-dd');

        try {
            const racingResult = await GetRacingDataQuery(raceDay, meeting?.venueCode?.value ?? '');
            //    判斷是否同一天,同一場
            const parsedDate1 = raceDay;
            const parsedDate2 = racingResult[0].date;
            const isSameDayResult = isSameDay(parsedDate1, parsedDate2);
            const isSameVenueCode = meeting?.venueCode?.value === racingResult[0].venueCode;
            // console.log('isSameVenueCode---', isSameVenueCode);
            // setNoQueryRace(isSameDayResult && isSameVenueCode);
            if (!isSameDayResult || !isSameVenueCode) {
                updateShowChanges(false);
                setRacesList([]);
                bettingStrategyStore.setResetList();
                return;
            }
            // console.log('date =========', isSameDayResult);
            setRacesList(racingResult.length > 0 ? racingResult[0].races ?? [] : []);
            displayManualInput
                ? updateShowChanges(true)
                : updateShowChanges(racingResult.length > 0);
        } catch (error) {
            console.error('Error fetching odds data:', error);
        }
    };

    const queryGQL = async () => {
        await getRacingData();
        await getOddsData();
    };

    // 获取odds和racing数据
    useEffect(() => {
        if (displayManualInput || !isBetPickEntry) {
            updateShowChanges(true);
            return;
        }
        queryGQL();

        const interval = setInterval(() => {
            queryGQL(); // 每30秒调用
        }, 30000);

        return () => clearInterval(interval); // 清除计时器
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        const raceNo = content?.betpickLink?.targetItem?.race?.raceNo?.numberValue ?? 0;
        const raceObj: any = racesList?.find((i: any) => i.no === raceNo);
        setRaceRuner(raceObj?.runners ?? []);
        // console.log('racesList-----', racesList);
    }, [content?.betpickLink?.targetItem?.race?.raceNo?.numberValue, racesList]);

    if (!detail) {
        return <></>;
    }
    return (
        <div className='py-[6px]'>
            {!displayManualInput ? (
                racesList.length > 0 ? (
                    <BetPickNewEntry
                        type={'race'}
                        betpickDetail={detail}
                        raceRunner={raceRunner}
                        oddsList={oddsList ?? []}
                        videoEnable={content.betpickVideoEnabled?.boolValue}
                        jsBridge={jsBridge}
                        contentBlock={contentBlock}
                    ></BetPickNewEntry>
                ) : (
                    <></>
                )
            ) : (
                <BetPickEntry
                    videoEnable={content.betpickVideoEnabled?.boolValue}
                    type={'leader'}
                    betpickDetail={detail}
                    jsBridge={jsBridge}
                    contentBlock={contentBlock}
                ></BetPickEntry>
            )}
        </div>
    );
}

export default BetPickLink;
